export default __webpack_public_path__ + "static/media/Common-ground.9a3b476b.svg";